module.exports = __webpack_public_path__ + "iq.svg?58949f0e715f2f6c05cd8b4d9234f9e2";